import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { ConditionParam } from '~/types/condition-param';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 数値の範囲に基づいて数値配列を生成する汎用関数
 *
 * @param min - 範囲の最小値
 * @param max - 範囲の最大値
 * @param step - ステップサイズ
 * @returns 指定された範囲の数値配列
 */
export function generateNumberRange(
  min: number,
  max: number,
  step = 100,
): number[] {
  const results: number[] = [];
  for (let value = min; value <= max; value += step) {
    results.push(value);
  }
  return results;
}

// キャメルケースからスネークケースに変換
export function camelToSnake(str: string): string {
  return str.replace(/([A-Z])/g, '_$1').toLowerCase();
}

export function isNumber(value: string): boolean {
  return typeof value === 'string' && !isNaN(Number(value));
}

export function formatAnnualSalaryBySymbol(conditionText: string): string {
  return conditionText
    .replace(/(\d+)万円以上/, '$1万円〜')
    .replace(/(\d+)万円以下/, '〜$1万円')
    .replace(/〜〜/, '〜');
}

// （数字）万円という文字列の最初に”年収”をつける
export function putJaSalaryText(targetStr: string): string {
  return targetStr.replace(/(\d+)万円/, '年収$1万円');
}

// 求人一覧の見出しの一部のテキストを生成
export function generateJobSearchTitle(
  conditionText: string,
  conditionParams: ConditionParam[],
): string {
  // conditionTextにxxx万円が存在する場合、年収xxx万円として表示する
  const conditionTextFormatted = putJaSalaryText(conditionText);

  if (conditionParams.length === 0) {
    return `建設業界の`;
  } else if (conditionParams.length === 1) {
    const allowedConditionTypes = [
      'annualSalaryMin',
      'prefecture',
      'contract',
      'feature',
    ];
    if (allowedConditionTypes.includes(conditionParams[0].type)) {
      return `${conditionTextFormatted}の建設業界の`;
    }
  } else if (conditionParams.length === 2) {
    const allowedConditionPrefectureAndCity = ['prefecture', 'city'];
    if (
      allowedConditionPrefectureAndCity.includes(conditionParams[0].type) &&
      allowedConditionPrefectureAndCity.includes(conditionParams[1].type)
    ) {
      return `${conditionTextFormatted}の建設業界の`;
    }
  }

  return `${conditionTextFormatted}の`;
}
